/**
 * @fileoverview gRPC-Web generated client stub for reconpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reconpb/fractionalshare.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reconpb = require('./fractionalshare_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.FractionalShareReconServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.FractionalShareReconServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListFractionalShareReconRequest,
 *   !proto.reconpb.ListFractionalShareReconResponse>}
 */
const methodDescriptor_FractionalShareReconService_ListFractionalShareRecon = new grpc.web.MethodDescriptor(
  '/reconpb.FractionalShareReconService/ListFractionalShareRecon',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListFractionalShareReconRequest,
  proto.reconpb.ListFractionalShareReconResponse,
  /**
   * @param {!proto.reconpb.ListFractionalShareReconRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListFractionalShareReconResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListFractionalShareReconRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListFractionalShareReconResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListFractionalShareReconResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.FractionalShareReconServiceClient.prototype.listFractionalShareRecon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.FractionalShareReconService/ListFractionalShareRecon',
      request,
      metadata || {},
      methodDescriptor_FractionalShareReconService_ListFractionalShareRecon,
      callback);
};


/**
 * @param {!proto.reconpb.ListFractionalShareReconRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListFractionalShareReconResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.FractionalShareReconServicePromiseClient.prototype.listFractionalShareRecon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.FractionalShareReconService/ListFractionalShareRecon',
      request,
      metadata || {},
      methodDescriptor_FractionalShareReconService_ListFractionalShareRecon);
};


module.exports = proto.reconpb;

